/**
 * Query used to get RFXRequest detail.
 * Below are the list of services that it talks to:
    * AWSSCMRFXService
 */
import { gql } from '@apollo/client';

import { LoadRFXRequestArgs } from '../LoadRFXRequest';
import { processResponse } from "./helper";

export const loadRFXRequestQuery = gql `
query loadRFXRequest(
    $id: LoadRFXRequestInput!
) {
    loadRFXRequest(
        id: $id
    ) {
      rfxRequest {
        rfxRequestRevisionedId {
            id {
                value
            }
            revision
        }
        rfxRequestVersion
        rfxRequestClassId {
            value
        }
        rfxResponseClassId {
            value
        }
        rfxLineItemClassId {
            value
        }
        businessId {
            value
        }
        region {
            value
        }
        beginAt
        dueAt
        name
        type
        buyer {
            value
        }
        ingestionId {
            value
        }
        commodityInformation {
            rootId {
                value
            }
            commodityIds {
                value
            }
            category {
                value
            }
        }
        currency
        suppliers {
            supplierId {
                value
            }
            supplierName {
                value
            }
            contactId {
                value
            }
            contactSource
            contracts {
                effectiveDate
                termType
                expiryDate
                renewalType
                contractCentralId
            }
            serviceLevelAgreements {
                serviceLevelAgreementType
                emergencyResponseServiceLevelAgreement
                serviceLevelAgreementProvision
            }
            countryCode
            incoterm
            qualificationStatus
            vendorServiceCurrencies
            selectedCurrencyValid
        }
        properties {
            id {
                value
            }
            value {
                valueString {
                    value
                }
                dataType {
                    value
                }
            }
        }
        documents {
            documentType
            supplierIds {
                value
            }
            attachment {
                externalId
                version
                filename
                size
                format
                description
                stagingS3Uri
                status
                createdDate {
                  value
                  format
                }
                lastModifiedDate {
                  value
                  format
                }
            }
        }
        generalInformation {
            overview
            processDetail
        }
        attributes {
            acknowledgementRequirement
            ndaRequirement
            participationConfirmationRequirement
        }
        lifeCycle {
            lifeCycleGraphId
            lifeCycleState {
                name
                version
            }
            lifeCycleVersion
        }
      }
    }
}`;

export default function loadRFXRequest(this: any, request: LoadRFXRequestArgs) {
    return processResponse(this.query({
        query: loadRFXRequestQuery,
        variables: request,
        fetchPolicy: 'network-only'
    }), 'loadRFXRequest');
}